import request from "@/axios";

/** 根据手机号查找对应的UID */
export const getUidByMobile = params => {
  return request({
    url: "/lebo-addition/web/appPlugin/getUidByMobile",
    method: "get",
    params
  });
};

/** 根据查询条件查询插件版本分布情况 */
export const getPluginDistribution = data => {
  return request({
    url: "/lebo-addition/web/appPlugin/getAppPluginCountList",
    method: "post",
    data
  });
};
